<!-- Title -->
<div class="text-center" *ngIf="page < 14">
    <h1>Module 1 - Communication and Conflict Resolution</h1>
</div>

<!-- Module Content -->
<div id="module1">
    <section>
        <div *ngIf="page===1">
            <div class="container content-box module-content">

                <!-- EDIT PAST THIS LINE -->


                <h2>Communication and Conflict Resolution</h2>
                <p>Without good communication skills it is difficult to maintain a positive working relationship with your landlord and your neighbors. Maintaining positive relationships is important because it makes renting more enjoyable. You need to get
                    along with your landlord and neighbors because you need good references to rent another apartment. The following information can help you know who to talk to about a problem, how to get your point across, how to be a good listener,
                    and how to settle conflicts.</p>

                <!-- Demo: 30 Seconds -->
                <!-- <app-youtube-player #video1 src="https://www.youtube.com/embed/w01V5FI03MQ" width="900" height="620" autoplay></app-youtube-player> -->

                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" [routerLink]="'/RentWise'"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
                <!-- <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video1.duration / video1.speed" [delay-until]="video1.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button> -->
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===2">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Landlord or Neighbor: Who Should I Talk to About the Problem?</h2>
                <p>When problems come up, it may be hard to know who to talk to. Some problems, such as a leaky sink or a broken security door should be reported to your landlord. Problems such as noise, tenants parking in the wrong parking space, or kids
                    running in the hallway should be discussed with your neighbor. Tenants should try to resolve neighbor problems between themselves. Involve the landlord as a last resort. Landlords do not appreciate being asked to get involved in neighbor
                    problems.
                </p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===3">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Active Listening</h2>
                <p>In high stress situations we are often so busy being upset that we don’t listen to what is being said to us. In many cases we assume we know what the person is going to say and are busy thinking about our response rather than what is actually
                    being said. Use active listening skills to avoid conflicts:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Face the person who is speaking and focus your attention on what is being said.</li>
                    <li class="bullet-point">Don’t interrupt except to ask questions to clear up things you do not understand.</li>
                    <li class="bullet-point">When the person finishes, restate in your own words what you heard said.</li>
                    <li class="bullet-point">Ask the person if he or she thinks you correctly heard what was said.</li>
                    <li class="bullet-point">Respond to what the person said.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===4">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Positive Messages</h2>
                <p>Positive messages go a long way toward solving communication problems. Just as our emotions can get in the way of listening, they can get in the way of clearly expressing ourselves. We do so much accusing or blaming that we don’t communicate
                    what we really want from the other person. Use the rules listed below to help deliver positive messages:</p>
                <ol class="numbered-list">
                    <li class="number">Own the message. Use “I,” not “you” or “they” or “we.” Example: “I want you to move your car out of my parking spot” instead of “You always park in my spot.”</li>
                    <li class="number">Discuss one issue at a time. Don’t use the “laundry list” approach.</li>
                    <li class="number">Describe the facts of the situation:</li>
                    <ul class="bullet-points">
                        <li class="bullet-point">What needs to be repaired or changed.</li>
                        <li class="bullet-point">What you have already done to fix it.</li>
                        <li class="bullet-point">How it is affecting you and your family.</li>
                    </ul>
                    <li class="number">Don’t call the other person names or make accusations because:</li>
                    <ul class="bullet-points">
                        <li class="bullet-point">You will put the person on the defensive.</li>
                        <li class="bullet-point">He or she may meet your negative expectation.</li>
                        <li class="bullet-point">All you really know is what has happened to you.</li>
                    </ul>
                    <li class="number">Start a conversation in a conflict situation only when you are calm and can stay calm.</li>
                </ol>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>
    <section *ngIf="page===5">
        <div *ngVar="{ all: false, card: [false,false,false,false,false,false,false,false] } as flipped">
            <div class="container content-box module-content">
                <h2>Activity</h2>
                <i>Each of the following flashcards contain statements that are NOT very effective for postive communication. Think about rephrasing these statements into an "I" message that conveys a more positive message. Then, click each card to see a correctly reworded example.</i>
                <div class="flip-cards">
                    <div class="flip-card" (click)="flipped.card[0] = !flipped.card[0]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[0]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>You are always so loud. I don't understand how you can be so inconsiderate!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I want you to quiet down. It is keeping me up at night.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[1] = !flipped.card[1]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[1]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>What do you mean I can't have people over? You can't tell me who can and cannot stay with me!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I am able to have anyone I want over. I will make sure to not disrupt you in the future.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[2] = !flipped.card[2]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[2]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>Clean up the kitchen!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I would appreciate it if you can clean up the kitcken. I am struggling to cook in there currently.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[3] = !flipped.card[3]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[3]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>Move your car or I am getting it towed!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I want you to move your car. It is blocking me in.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[4] = !flipped.card[4]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[4]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>Do you think you are the only one living here? You need to think about other people's safety and quit leaving the door open!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I would appreciate it if you would close the door after you open it. It is not safe for me when it is left open.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[5] = !flipped.card[5]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[5]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>Your stupid kids are always playing in the hall and being noisy. You need to put a stop to it now!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I would like you to tell your kids to quiet down when they play in the hall.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[6] = !flipped.card[6]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[6]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>You better get up here and fix my sink!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I would be very happy if you fixed my sink.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flip-card" (click)="flipped.card[7] = !flipped.card[7]; flipped.all = all(flipped.card, true)" [class.flipped]="flipped.card[7]">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <h5>The carpet in the hall is always filthy. You should clean it!</h5>
                            </div>
                            <div class="flip-card-back">
                                <h5>I would appreciate it if you cleaned the carpet in the hall.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="flipped.all && next($event)" [ngClass]="flipped.all ? '' : 'disabled hoverable'" [matTooltip]="flipped.all ? '' : 'To proceed, click each card to see a correctly reworded example.'">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>
    <section>
        <div *ngIf="page===6">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Communicating with Your Landlord</h2>
                <p>Steps in communicating with your landlord:</p>
                <ol class="numbered-list">
                    <li class="number">Before you call, document the situation:</li>
                    <ul class="bullet-points">
                        <li class="bullet-point">What happened?</li>
                        <li class="bullet-point">When did you notice it?</li>
                        <li class="bullet-point">What have you already done about it?</li>
                        <li class="bullet-point">What do you want done?</li>
                    </ul>
                    <li class="number">Call the landlord and give him or her the information about the situation.</li>
                    <li class="number">After the landlord responds, restate in your own words what you heard said.</li>
                    <li class="number">Ask the landlord if he or she thinks you heard what was said correctly.</li>
                    <li class="number">Respond to what the landlord said.</li>
                </ol>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section *ngIf="page===7">
        <div *ngVar="{ downloaded: false, validate: false } as content">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Sample Letter Requesting a Repair</h2>
                <p>The following sample letter is an example. When you write your letter, use the current date and real names, addresses, and phone numbers. Give the full name and address of the person to whom you are supposed to request repairs as stated
                    in your lease agreement. Change the sample letter so that it has information about your situation and the people you have been dealing with.</p>
                <p>Do not make threats unless you know that you can legally carry them out and have specific actions in mind. For example, do not threaten to withhold rent, unless an attorney or a rental counselor advises this. Be specific about the repair,
                    when you first noticed the problem, what you have done to fix it, and prior contacts requesting repairs.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf(); content.downloaded = true" [class.invalid]="content.validate && !content.downloaded">Download Handout</button>

                    <div class="invalid-feedback d-block" *ngIf="content.validate && !content.downloaded">
                      Download and review handout first.
                    </div>
                </div>

            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="content.downloaded ? next($event) : content.validate = true" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===8">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Steps in Settling a Conflict</h2>
                <p>Many of us try to avoid conflicts. However, that is not always possible or even a good idea. Some conflict is inevitable. It is usually best to find a solution rather than to ignore the issue and hope that it will go away. Use active listening
                    and positive messages to settle conflicts. The following guidelines are helpful:</p>
                <ol class="numbered-list">
                    <li class="number">Set a time to meet when you are both calm and not busy.</li>
                    <li class="number">Begin by giving the other person a “positive message” about what is bothering you.</li>
                    <li class="number">Listen carefully to the other person’s point of view.</li>
                    <li class="number">Decrease areas of disagreement by finding areas where you agree.</li>
                    <li class="number">Offer solutions where you both give a little and get a lot.</li>
                    <li class="number">Don’t force a solution.</li>
                    <li class="number">If you cannot resolve the conflict, suggest a mediator whom you both respect.</li>
                </ol>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===9">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video src="https://www.youtube.com/embed/wJF9ri3LkgA" width="900" height="620" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video.duration / video.speed" [delay-until]="video.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===10">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Landlord or Tenant: Who Should Make Repairs?</h2>
                <p>If something goes wrong in your rental unit, try to figure out if it is something you should fix yourself. Unplugging a toilet or sink, changing light bulbs or replacing batteries in a smoke detector are things tenants can easily fix themselves.
                    You should contact the landlord as soon as possible about serious problems, especially problems that damage the building such as a water leak or are a danger to your health and safety.</p>
                <h3>Resources to Determine Responsibility</h3>
                <ul class="bullet-points">
                    <li class="bullet-point">Lease agreement</li>
                    <li class="bullet-point">Your completed Rental Condition Checklist (Worksheet 10)</li>
                    <li class="bullet-point">Government regulations</li>
                    <li class="bullet-point">Common sense</li>
                </ul>
                <h3>Typical Responsibilities</h3>
                <p>Check local codes for regulations that apply in your area.</p>
                <h4>Typical Landlord Responsibilities</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Corrects building or housing code violations affecting the unit or common areas.</li>
                    <li class="bullet-point">Provides hot and cold water and operational sewage drains.</li>
                    <li class="bullet-point">Maintains heating equipment so that it is safe and capable of maintaining temperatures.</li>
                    <li class="bullet-point">Keeps electrical system in safe operating condition.</li>
                    <li class="bullet-point">Corrects other defects that could cause a substantial safety risk to tenants.</li>
                    <li class="bullet-point">Makes repairs required by normal wear and tear.</li>
                    <li class="bullet-point">Maintains common areas in reasonable condition.</li>
                    <li class="bullet-point">Maintains equipment, such as heating systems, water heater, elevators, and air conditioning that serve the unit and common spaces.</li>
                </ul>
                <h4>Typical Tenant Responsibilities</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Pays for or makes repairs required because of the tenant‘s negligence or improper use. Landlords may choose to make such repairs at tenant’s expense.</li>
                    <li class="bullet-point">Keeps the plumbing clean and uses electrical, plumbing, heating and cooling facilities in a reasonable manner.</li>
                    <li class="bullet-point">Reports problems to landlord as soon as they are noticed.</li>
                    <li class="bullet-point">Maintains unit or area in reasonable condition.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===11">
            <div class="container content-box module-content">
                <div id="activity1">
                    <h3>Activity: Landlord or Neighbor: Who Should I Talk To About My Problem? </h3>
                    <form class="radio wrapper">
                        <!-- 1 -->
                        <div class="question1">
                            <br> <b> My sink is leaking.</b> <br>
                            <input name="question1" type="radio" [value]="true" [(ngModel)]="model.question1" (click)="question1()"> Neighbor<br/>
                            <input name="question1" type="radio" [value]="false" [(ngModel)]="model.question1" (click)="question1()"> Landlord<br/>
                            <div *ngIf="model.question1 && question1Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is wrong.
                            </div>
                            <div *ngIf="!model.question1  && question1Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is correct.
                            </div>
                        </div>
                        <!-- 2 -->
                        <div class="question2">
                            <br> <b>Children are running in the hallways.</b> <br>
                            <input name="question2" type="radio" [value]="false" [(ngModel)]="model.question2" (click)="question2()"> Neighbor<br/>
                            <input name="question2" type="radio" [value]="true" [(ngModel)]="model.question2" (click)="question2()"> Landlord<br/>
                            <div *ngIf="model.question2 && question2Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is wrong.
                            </div>
                            <div *ngIf="!model.question2  && question2Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is correct
                            </div>
                        </div>
                        <!-- 3 -->
                        <div class="question3">
                            <br> <b> Loud music is coming from next door.</b> <br>
                            <input name="question3" type="radio" [value]="false" [(ngModel)]="model.question3" (click)="question3()"> Neighbor<br/>
                            <input name="question3" type="radio" [value]="true" [(ngModel)]="model.question3" (click)="question3()"> Landlord<br/>
                            <div *ngIf="model.question3 && question3Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is wrong.
                            </div>
                            <div *ngIf="!model.question3  && question3Picked" style="background-color: rgba(0, 128, 0, 0.25); font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is correct.
                            </div>
                        </div>
                        <!-- 4 -->
                        <div class="question4">
                            <br> <b> There is not enough parking. </b> <br>
                            <input name="question4" type="radio" [value]="true" [(ngModel)]="model.question4" (click)="question4()"> Neighbor<br/>
                            <input name="question4" type="radio" [value]="false" [(ngModel)]="model.question4" (click)="question4()"> Landlord<br/>
                            <div *ngIf="model.question4 && question4Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is wrong.
                            </div>
                            <div *ngIf="!model.question4  && question4Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is correct.
                            </div>
                        </div>
                        <!-- 5 -->
                        <div class="question5">
                            <br> <b> Security doors are broken.</b> <br>
                            <input name="question5" type="radio" [value]="true" [(ngModel)]="model.question5" (click)="question5()"> Neighbor<br/>
                            <input name="question5" type="radio" [value]="false" [(ngModel)]="model.question5" (click)="question5()"> Landlord<br/>
                            <div *ngIf="model.question5 && question5Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is wrong.
                            </div>
                            <div *ngIf="!model.question5  && question5Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is correct.
                            </div>
                        </div>
                        <!-- 6 -->
                        <div class="question6">
                            <br> <b>Garbage is being left in the hallway. </b> <br>
                            <input name="question6" type="radio" [value]="false" [(ngModel)]="model.question6" (click)="question6()"> Neighbor<br/>
                            <input name="question6" type="radio" [value]="true" [(ngModel)]="model.question6" (click)="question6()"> Landlord<br/>
                            <div *ngIf="model.question6 && question6Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is wrong.
                            </div>
                            <div *ngIf="!model.question6  && question6Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is correct.
                            </div>
                        </div>
                        <!-- 7 -->
                        <div class="question7">
                            <br> <b> My toilet keeps running after it is flushed. </b> <br>
                            <input name="question7" type="radio" [value]="true" [(ngModel)]="model.question7" (click)="question7()"> Neighbor<br/>
                            <input name="question7" type="radio" [value]="false" [(ngModel)]="model.question7" (click)="question7()"> Landlord<br/>
                            <div *ngIf="model.question7 && question7Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is wrong.
                            </div>
                            <div *ngIf="!model.question7  && question7Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is correct.
                            </div>
                        </div>
                        <!-- 8 -->
                        <div class="question8">
                            <br> <b> Security doors are often propped up. </b> <br>
                            <input name="question8" type="radio" [value]="false" [(ngModel)]="model.question8" (click)="question8()"> Neighbor<br/>
                            <input name="question8" type="radio" [value]="true" [(ngModel)]="model.question8" (click)="question8()"> Landlord<br/>
                            <div *ngIf="model.question8 && question8Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You answered Landlord, that is wrong.
                            </div>
                            <div *ngIf="!model.question8  && question8Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;You answered Neighbor, that is correct.
                            </div>
                        </div>
                        <div *ngIf="flag" style="color:red" class="warning">
                            You must answer all questions correctly before moving on
                        </div>
                    </form>
                </div>
            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back(); resetFlag();"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button *ngIf="activityOneCorrect()" type="button" class="btn waves-dark w-25" (click)="next() && resetFlag();">Next<i class="fas fa-angle-right ml-3"></i></button>
                <button *ngIf="!activityOneCorrect()" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===12">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Government Regulations: Nebraska</h2>
                <p><i>For more information on the Nebraska Landlord-Tenant Act visit <a href="https://nrec.nebraska.gov/legal/landlordacttoc.html">www.nrec.ne.gov/legal/landlordacttoc.html</a> or <a href="https://www.legalaidofnebraska.org/wp-content/uploads/2019/05/Landlord-and-Tenant-handbook-2017.pdf">https://www.legalaidofnebraska.org/wp-content/uploads/2019/05/Landlord-and-Tenant-handbook-2017.pdf</a></i></p>
                <h3>Landlord:</h3>
                <p>The Nebraska Landlord-Tenant Act requires landlords to comply with the community’s minimum housing codes concerning health and safety. If the community does not have a housing code, the Nebraska law requires certain minimum responsibilities
                    of the landlord.</p>
                <p>The minimum responsibilities are:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Make repairs to keep the premises in a fit and habitable or livable condition.</li>
                    <li class="bullet-point">Keep common areas clean and safe.</li>
                    <li class="bullet-point">Maintain facilities supplied (such as the furnace, plumbing, and elevators).</li>
                    <li class="bullet-point">Provide garbage cans and supply reasonable hot and cold running water.</li>
                </ul>
                <h3>Tenant:</h3>
                <ul class="bullet-points">
                    <li class="bullet-point">Comply with all community housing codes.</li>
                    <li class="bullet-point">Keep the unit as clean and safe as conditions permit, dispose of garbage in a clean safe manner.</li>
                    <li class="bullet-point">Keep the plumbing clean and use electrical, plumbing, heating and cooling facilities in a reasonable manner.</li>
                    <li class="bullet-point">Do not deliberately or negligently destroy, damage or remove a part of premises.</li>
                    <li class="bullet-point">When moving, leave the property in a clean condition except for ordinary wear and tear.</li>
                    <li class="bullet-point">Tenants and guests conduct themselves in a manner which does not disturb their neighbors.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===13">
            <div class="container content-box module-content">
                <!-- Start Activity 7 -->
                <div id="activity1">
                    <h3>Activity: Landlord or Tenant: Who is Responsible? </h3>
                    <div class="radio wrapper">
                        <!-- 1 -->
                        <div class="question1">
                            <br> <b> Your unit's hallway light bulb burns out.</b> <br>
                            <input name="question1" type="radio" [value]="true" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> Tenant<br/>
                            <input name="question1" type="radio" [value]="false" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q1 && model7_Q1" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;It is the landlord's responsibility to maintain common areas.
                            </div>
                            <div *ngIf="!model7.model7_Q1  && model7_Q1" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>
                        <!-- 2 -->
                        <div class="question2">
                            <br> <b>The light over your kitchen sink burns out.</b> <br>
                            <input name="question2" type="radio" [value]="false" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> Tenant<br/>
                            <input name="question2" type="radio" [value]="true" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q2 && model7_Q2" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;It is the tenant's responsibility to change light bulbs in his or her own unit.
                            </div>
                            <div *ngIf="!model7.model7_Q2  && model7_Q2" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 3 -->
                        <div class="question3">
                            <br> <b> Your front door lock does not work.</b> <br>
                            <input name="question3" type="radio" [value]="true" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> Tenant<br/>
                            <input name="question3" type="radio" [value]="false" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q3 && model7_Q3" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;It is the landlord's responsibility to maintain a unit to code. A lock that does not work is a safety issue and must be addressed immediately.
                            </div>
                            <div *ngIf="!model7.model7_Q3  && model7_Q3" style="background-color: rgba(0, 128, 0, 0.25); font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 4 -->
                        <div class="question4">
                            <br> <b>You find bugs in the unit on the second day after moving into the unit. </b> <br>
                            <input name="question4" type="radio" [value]="false" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> Tenant<br/>
                            <input name="question4" type="radio" [value]="true" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q4 && model7_Q4" style="background-color: rgba(255,0,0,0.25);font-weight: bolder; font-size: 18px;">
                                &nbsp;You may have carried insects into the unit with your belongings. Cardboard boxes should be unpacked and disposed of immediately. Ask the landlord if the apartment was checked for pests and if there have been problems with pests.
                            </div>
                            <div *ngIf="!model7.model7_Q4  && model7_Q4" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 5 -->
                        <div class="question5">
                            <br> <b> Your child throws a ball through a windowpane.</b> <br>
                            <input name="question5" type="radio" [value]="false" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> Tenant<br/>
                            <input name="question5" type="radio" [value]="true" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q5 && model7_Q5" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;Any damage caused by children or guests is the tenant's responsibility.
                            </div>
                            <div *ngIf="!model7.model7_Q5  && model7_Q5" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 6 -->
                        <div class="question6">
                            <br> <b> There is no hot water. </b> <br>
                            <input name="question6" type="radio" [value]="true" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> Tenant<br/>
                            <input name="question6" type="radio" [value]="false" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q6 && model7_Q6" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;The landlord should address this problem immediately because it is a safety issue.
                            </div>
                            <div *ngIf="!model7.model7_Q6  && model7_Q6" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 7 -->
                        <div class="question7">
                            <br> <b> The bathroom exhaust fan is broken. </b> <br>
                            <input name="question7" type="radio" [value]="true" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> Tenant<br/>
                            <input name="question7" type="radio" [value]="false" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q7 && model7_Q7" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;Unless a Tenant misuses the exhaust fan, it is the landlord's responsibility to maintain the unit, including equipment and systems.
                            </div>
                            <div *ngIf="!model7.model7_Q7  && model7_Q7" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 8 -->
                        <div class="question8">
                            <br> <b> Replacing things that belong in the unit like window screens or light fixtures.</b> <br>
                            <input name="question8" type="radio" [value]="true" [(ngModel)]="model7.model7_Q8" (click)="m7_Q8()"> Tenant<br/>
                            <input name="question8" type="radio" [value]="false" [(ngModel)]="model7.model7_Q8" (click)="m7_Q8()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q8 && model7_Q8" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;You are not allowed to remove moveable pieces that belong with the unit.
                            </div>
                            <div *ngIf="!model7.model7_Q8  && model7_Q8" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 9 -->
                        <div class="question9">
                            <br> <b> Your sink drain is plugged.</b> <br>
                            <input name="question9" type="radio" [value]="false" [(ngModel)]="model7.model7_Q9" (click)="m7_Q9()"> Tenant<br/>
                            <input name="question9" type="radio" [value]="true" [(ngModel)]="model7.model7_Q9" (click)="m7_Q9()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q9 && model7_Q9" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;Many landlords will fix this type of problem; however, they also may charge you to do it. Try to safely unplug it yourself if you cannot call the landlord immediately. Avoid damaging the sink and pipes.
                            </div>
                            <div *ngIf="!model7.model7_Q9  && model7_Q9" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 10 -->
                        <div class="question10">
                            <br> <b> Making sure the rental condition checklist is completed when moving in.</b> <br>
                            <input name="question10" type="radio" [value]="false" [(ngModel)]="model7.model7_Q10" (click)="m7_Q10()"> Tenant<br/>
                            <input name="question10" type="radio" [value]="true" [(ngModel)]="model7.model7_Q10" (click)="m7_Q10()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q10 && model7_Q10" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;It is the tenant's responsibility and the tenant should keep a signed copy.
                            </div>
                            <div *ngIf="!model7.model7_Q10  && model7_Q10" style="background-color: rgba(0, 118, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>

                        <!-- 11 -->
                        <div class="question11">
                            <br> <b> Paying for normal wear and tear of the unit.</b> <br>
                            <input name="question11" type="radio" [value]="true" [(ngModel)]="model7.model7_Q11" (click)="m7_Q11()"> Tenant<br/>
                            <input name="question11" type="radio" [value]="false" [(ngModel)]="model7.model7_Q11" (click)="m7_Q11()"> Landlord<br/>
                            <div *ngIf="model7.model7_Q11 && model7_Q11" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                                &nbsp;Landlords should not deduct for normal wear and tear, including minor chipping and discoloration of paint.
                            </div>
                            <div *ngIf="!model7.model7_Q11  && model7_Q11" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                                &nbsp;Correct!
                            </div>
                        </div>
                        <div *ngIf="flag" style="color:red" class="warning">
                            You must answer all questions correctly before moving on
                        </div>
                    </div>
                </div>
            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button *ngIf="activityTwoCorrect()" type="button" class="btn waves-dark w-25" (click)="next() && resetFlag();">Quiz<i class="fas fa-angle-right ml-3"></i></button>
                <button *ngIf="!activityTwoCorrect()" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">Quiz<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>
</div>

<section *ngIf="page===14">
    <app-quiz-questions [questions]="questions" [moduleNumber]="1" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>
